import createSelector from "../../utils/reselect";

const milestoneStateData = (state) => {
  const { milestone } = state;
  return milestone || {};
};

export const milestoneLoading = createSelector(milestoneStateData, (milestoneItems) =>
  milestoneItems.get("milestoneLoading")
);


export const milestoneActionLoading = createSelector(milestoneStateData, (milestoneItems) =>
  milestoneItems.get("milestoneActionLoading")
);

export const milestones = createSelector(milestoneStateData, (milestoneItems) =>
  milestoneItems.get("milestoneItems")
);

export const milestonesLoading = createSelector(milestoneStateData, (milestoneItems) =>
  milestoneItems.get("milestonesLoading")
);

export const milestoneItem = createSelector(milestoneStateData, (milestoneItems) =>
  milestoneItems.get("milestoneItem")
);

export const milestoneError = createSelector(milestoneStateData, (milestoneItems) =>
  milestoneItems.get("error")
);

export const milestonesPagination = createSelector(milestoneStateData, (milestoneItems) =>
  milestoneItems.get("milestonePagination")
);